import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import NavigationTitle, { LayoutType } from 'ui/NavigationTitle/NavigationTitle';
import api from 'api/api';
import Loader from 'ui/Loader/Loader';
import { IDocument, IRegulatoryResponse } from './regulatoryContent';
import styles from './RegulatoryContainer.module.css';

import regulatoryIcon from 'assets/icons/regulatoryIcon.svg';

const RegulatoryContainer = () => {
  const [loadingData, setLoadingData] = useState(false);
  const [filesArray, setFilesArray] = useState<IDocument[]>([]);
  const history = useHistory();
  const goBack = () => history.goBack();

  const fetchRegulatoryFiles = () => {
    setLoadingData(true);
    api
      .get('support/regulatoryDirectivesFiles', {}, false, false)
      .then((response: IRegulatoryResponse) => {
        setFilesArray(response.regulatoryDirectives);
        setLoadingData(false);
      })
      .catch((e) => console.error(e))
      .finally(() => {
        setLoadingData(false);
      });
  };
  useEffect(fetchRegulatoryFiles, [filesArray]);

  return (
    <>
      {loadingData && <Loader />}
      <div className={styles.container}>
        <NavigationTitle to="#/" onClick={goBack} layoutType={LayoutType.support}>
          Regulatory Directives
        </NavigationTitle>
        <section className={styles.listContainer}>
          <List disablePadding>
            {filesArray.map(({ fileName, url }) => (
              <ListItem key={fileName} disableGutters className={styles.listItem}>
                <a href={url} target="_blank" rel="noreferrer" className={styles.linkItem}>
                  <img src={regulatoryIcon} alt="icon" className={styles.linkIcon} />
                  {fileName}
                </a>
              </ListItem>
            ))}
          </List>
        </section>
      </div>
    </>
  );
};

export default RegulatoryContainer;
